const indexItems = [
  { icon: 'ri-sun-line', label: '日漫专区', desc: '热血与经典', color: 'bg-primary-100 text-primary-700' },
  { icon: 'ri-flag-2-line', label: '国漫精选', desc: '崛起新势力', color: 'bg-accent-100 text-accent-700' },
  { icon: 'ri-kakao-talk-line', label: '韩漫热榜', desc: '彩色条漫风', color: 'bg-secondary-100 text-secondary-700' },
  { icon: 'ri-rocket-line', label: '新番速递', desc: '第一时间追', color: 'bg-primary-100 text-primary-700' },
  { icon: 'ri-history-line', label: '经典重温', desc: '永恒神作', color: 'bg-accent-100 text-accent-700' },
  { icon: 'ri-film-line', label: '剧场版', desc: '大银幕精华', color: 'bg-secondary-100 text-secondary-700' },
  { icon: 'ri-dvd-line', label: 'OVA合集', desc: '特别篇珍藏', color: 'bg-primary-100 text-primary-700' },
  { icon: 'ri-fire-line', label: '少年热血', desc: '燃到停不住', color: 'bg-accent-100 text-accent-700' },
  { icon: 'ri-heart-line', label: '少女恋爱', desc: '甜蜜心动', color: 'bg-secondary-100 text-secondary-700' },
];

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-3xl font-heading text-foreground-950">主题索引</h2>
          <p className="mt-3 text-sm text-foreground-600">按类型快速找到你想看的动漫，日漫韩漫国漫分类清晰</p>
        </div>
        <div className="grid grid-cols-3 md:grid-cols-3 lg:grid-cols-9 gap-3 md:gap-4">
          {indexItems.map((item) => (
            <a
              key={item.label}
              href={`#carousel`}
              onClick={(e) => { e.preventDefault(); document.querySelector('#carousel')?.scrollIntoView({ behavior: 'smooth' }); }}
              className="flex flex-col items-center gap-2 p-4 md:p-5 rounded-xl bg-background-100 hover:bg-background-200 transition-colors cursor-pointer group"
            >
              <div className={`w-10 h-10 md:w-12 md:h-12 rounded-xl flex items-center justify-center ${item.color} transition-transform group-hover:scale-110`}>
                <i className={`${item.icon} text-lg md:text-xl`}></i>
              </div>
              <span className="text-xs md:text-sm font-medium text-foreground-800 whitespace-nowrap">{item.label}</span>
              <span className="text-[10px] md:text-xs text-foreground-500">{item.desc}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}